import React, {Component} from 'react';
import IconTitle from "../../components/iconTitle";
import {faAngleDown, faAngleRight} from "@fortawesome/pro-solid-svg-icons";
import {Collapse, Container, Row} from "react-bootstrap";
import UniteEnseignement from "./uniteEnseignement";

class NiveauCours extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: props.item.Cours.filter(f => !f.CreditsValides && !f.NotSelectable && !f.IsDispense).length > 0,
        }
    }

    changeOpen() {
        this.setState({open: !this.state.open})
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.item !== this.props.item || this.state.open !== nextState.open;
    }

    render() {
        return (
            <div className={"mb-5"}>
                {/*eslint-disable-next-line*/}
                <a
                    onClick={() => this.changeOpen()}
                    aria-controls="example-collapse-text"
                    aria-expanded={this.state.open}
                >
                    <IconTitle icon={this.state.open ? faAngleDown : faAngleRight}
                               content={this.props.item.NiveauCoursLibelle}/>
                </a>
                <Collapse in={this.state.open}>
                    <div>
                        <Container>
                            <Row>
                                {this.props.item.Cours.map((ue) => <UniteEnseignement key={ue.UniteEnseignementID}
                                                                                      updateSelected={this.props.updateSelected.bind(this)}
                                                                                      item={ue}/>
                                )}
                            </Row>
                        </Container>
                    </div>
                </Collapse>
            </div>
        );
    }
}

export default NiveauCours;